import { toast } from "react-toastify";
import { apiSlice } from ".";

const filesApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    uploadImage: builder.mutation({
      query: ({ image, imageType,tag }) => ({
        url: `/AALuploader/AALuploadfiles?A=${imageType}&tag=${tag}`,
        method: "POST",
        body: image,
      }),
      async onQueryStarted(args, { queryFulfilled }) {
        toast.promise(queryFulfilled, {
          pending: "Uploading Image",
          success: "Image Uploaded",
          error: "Error Uploading Image",
        });
      },
    }),


   regeneratePDF: builder.mutation({
  query: (propertyId) => ({
    url: `/pdfGenerator/GeneratePropertyPDF?propertyId=${propertyId}`,
    method: "GET",
  }),
  async onQueryStarted(args, { queryFulfilled }) {
    toast.promise(queryFulfilled, {
      pending: "Generating Pdf",
      success: "Pdf Generated",
      error: "Error Generating Pdf",
    });
  },
}),

    // uploadPdf: builder.mutation({
    //   query: ({ propertyId }) => ({
    //     url: `/pdfGenerator/GeneratePropertyPDF?propertyId=${propertyId}`,
    //     method: "GET",
       
    //   }),

    //   async onQueryStarted(args, { queryFulfilled }) {
    //     toast.promise(queryFulfilled, {
    //       pending: "Generating Pdf",
    //       success: "Pdf Generated",
    //       error: "Error Generating Pdf",
    //     })
    //   },
    //   invalidatesTags: ["AgencyProperties"]
    // })


  }),
});

export const { useUploadImageMutation, useUploadPdfMutation, useRegeneratePDFMutation } = filesApi;
